<!-- Modal -->
<ng-template #projectSelector let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Selecionar Projeto</h4>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="cancelProjectSelection(modal)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-6 text-center" *ngFor="let projeto of projetos">
                <button
                    class="btn btn-outline-dark m-1"
                    (click)="selectProject(projeto, modal)">
                    {{ projeto.titulo_curto }}
                </button>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-blue material-button"
            (click)="cancelProjectSelection(modal)">
            Cancelar
        </button>
    </div>
</ng-template>
<div class="sidebar-project-selector" *ngIf="mostrarSeletor">
    <div
        class="d-flex flex-column justify-content-center align-items-center w-100">
        <div
            class="d-flex bg-secondary text-light justify-content-center align-items-center w-100">
            {{ current_project?.titulo_curto || 'Selecionar projeto' }}
        </div>
        <a (click)="openProjectSelector()" class="btn btn-blue rounded-0 w-100">
            <i class="fa fa-exchange" aria-hidden="true"></i> Trocar Projeto
        </a>
    </div>
</div>
